import { useCallback } from 'react';
import { type SortIndicator } from '../../hooks/use-sort-indicator';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import { type VehicleListColumnKey } from '../../VehicleList';
import useSetSortAsState from './use-set-sort-as-state';

export type OnSort = ({
  columnKey,
  sortingDirection,
}: {
  columnKey: VehicleListColumnKey;
  sortingDirection: 'asc' | 'desc';
}) => void;

interface UseOnSortProperties {
  sortIndicator: SortIndicator | null;
  updateQueryParameterValues: UpdateQueryParameterValues;
}

const useOnSort = ({ sortIndicator, updateQueryParameterValues }: UseOnSortProperties): OnSort => {
  const setSortAsState = useSetSortAsState(sortIndicator, updateQueryParameterValues);

  return useCallback(
    ({ columnKey, sortingDirection }) => {
      setSortAsState({ columnKey, sortingDirection });
    },
    [setSortAsState],
  );
};

export default useOnSort;
